<template>
  <div class="registrationComponent">
    <div class="form">
      <StepsRow
        v-if="step !== 6"
        :title="titles[step]"
        :activeStep="step"
      ></StepsRow>
      <StepsInfo
        @nextStep="nextStep($event)"
        @prevStep="prevStep($event)"
        @showTerms="showTerms"
        @showPrivecy="showPrivecy"
        :activeStep="step"
      ></StepsInfo>
      <div class="have-kit inside" v-show="step < 1">
        Already activated your kit?
        <router-link to="/login" tag="a" class="haveAccount-link">
          Sign in</router-link
        >
      </div>
    </div>
    <img
      src="../../images/bg/spinner.png"
      alt="Spinner"
      class="registration-spinner"
      v-if="step === 0"
    />
  </div>
</template>

<script>
import StepsRow from "./StepsRow";
import StepsInfo from "./StepsInfo";
import { mapActions } from "vuex";

export default {
  name: "RegistrationComponent",
  components: {
    StepsRow,
    StepsInfo
  },
  data() {
    return {
      step: 0,
      titles: [
        "Activate Your Kit",
        "Create Your Profile",
        "Notification",
        "Sampling Details",
        "Review & Confirm",
        "Next Steps"
      ]
    };
  },
  methods: {
    ...mapActions(["changeStep"]),
    showTerms() {
      this.$emit("showTerms", true);
    },
    showPrivecy() {
      this.$emit("showPrivecy", true);
    },
    nextStep(e) {
      this.step += e;
    },
    prevStep(e) {
      this.step -= e;
    }
  },
  created() {
    if (this.$route.query.step) {
      this.step = Number(this.$route.query.step);
    }
  },
  watch: {
    step() {
      this.changeStep(this.step);
    }
  },
  mounted() {
    if (localStorage.getItem("actkitid")) {
      this.step=1;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";

.registrationComponent {
  max-height: 100%;
  position: relative;
  padding-top: 100px;
}
.form {
  background-color: $white;
  width: 50%;
  max-width: 550px;
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  margin: 40px 0 0 auto;
  position: relative;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.have-kit {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: TTNormsMedium, sans-serif;
  color: $green;
  margin-top: 36px;
}

.haveAccount-link {
  color: $green;
  margin-left: 10px;
  font-family: TTNormsMedium, sans-serif;
}
.registration-spinner {
  display: none;
}
@media (max-width: 1024px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
  .got-mold-box {
    bottom: 200px;
  }
}
@media (max-width: 768px) {
  .form {
    width: 100%;
    margin: 0 auto;
    padding: 36px 20px 40px 20px;
  }
  .registrationComponent {
    height: auto;
    padding: 90px 0 50px 0;
  }
  .registration-spinner {
    display: flex;
    width: 68px;
    height: 68px;
    margin: 26px auto;
  }
}
</style>
